import React from 'react'

const EmailVerificationBackupOffer = (props) => {
  const {
    onAddBackup, onSkip, onNeverAskAgain, skipLoading,
  } = props

  return (
    <div className='emailVerificationFlow-backupOffer'>
      <div className='emailVerificationFlow-title'>Add a backup email</div>
      <div className='emailVerificationFlow-description'>
        A backup covers you if you ever lose access to your account email.
      </div>
      <button type='button' className='btn btn--blue btn--large' onClick={onAddBackup}>
        Add backup email
      </button>
      <div className='emailVerificationFlow-backupOffer-links'>
        <button type='button' className='emailVerificationFlow-linkBtn' onClick={onNeverAskAgain} disabled={skipLoading}>
          Don&apos;t ask me again
        </button>
        <button type='button' className='emailVerificationFlow-linkBtn' onClick={onSkip} disabled={skipLoading}>
          Not now
        </button>
      </div>
    </div>
  )
}

export default EmailVerificationBackupOffer
